import React from 'react';
import { FormattedTime as BaseFormattedTime } from 'react-intl';

const FormattedTimeWrapper = props => <BaseFormattedTime {...props} hour12={false} />;

export default FormattedTimeWrapper;
